import { useEffect } from "react";
import StepComplete from "../../../components/common/stepComplete/StepComplete";
import AppHeader from "../../../components/common/appHeader/AppHeader";
import { UserContext } from "./../../../App";
import { useDispatch } from "react-redux";
import { setIsComplete } from "@src/@slice/recommendHallSlice";
import HoneymoonSection from "@src/components/common/honeymoonSection/HoneymoonSection";
import { useRecommendHall } from "../../../utils/hooks/useRecommendHall";

const Complete = () => {
  const dispatch = useDispatch();
  const { hallData } = useRecommendHall();
  
  useEffect(() => {
    dispatch(setIsComplete({ bool: true }));
  }, []);
  
  // 예식일에서 첫 번째 년월 추출 및 포맷팅 (예: "2026년 5월" -> "26년 5월")
  const formatWeddingMonth = (yearMonths: string[]): string => {
    if (!yearMonths || yearMonths.length === 0) return "26년 9월"; // 기본값
    const firstMonth = yearMonths[0]; // 첫 번째 선택된 예식일
    
    // "2026년 5월" 형식 파싱
    const yearMatch = firstMonth.match(/(\d{4})년/);
    const monthMatch = firstMonth.match(/(\d{1,2})월/);
    
    if (yearMatch && monthMatch) {
      const year = yearMatch[1];
      const month = monthMatch[1];
      const shortYear = year.slice(-2); // "2026" -> "26"
      const monthNum = parseInt(month, 10); // "5" -> 5
      return `${shortYear}년 ${monthNum}월`;
    }
    
    // 기존 형식 지원 (YYYY-MM)
    const [year, month] = firstMonth.split("-");
    if (year && month) {
      const shortYear = year.slice(-2);
      const monthNum = parseInt(month, 10);
      if (!isNaN(monthNum)) {
        return `${shortYear}년 ${monthNum}월`;
      }
    }
    
    return "26년 9월"; // 기본값
  };
  
  const honeymoonTitle = formatWeddingMonth(hallData.hopeWedding.yearMonths);
  const linkChat = () => {
    window.location.href = "h2mwbell://chat";
  };
  return (
    <div>
      <AppHeader type="stack" actionItems={[{ name: "close" }]} />
      <StepComplete
        title={`짝짝짝!
				빠른 상담 신청이
				접수되었습니다.`}
        text={`고객님께서 신청하신 내용은 업체에서 확인 후
				상담 일정 확정을 위해 연락드릴 예정입니다.`}
      />
      <UserContext.Consumer>
        {(user) => (
          <>
            <div className="step-complete-noti" style={{ marginTop: -20 }}>
              <div>
                <span>💍</span>
                <p>
                  빠른 상담예약 신청 고객 대상 예물 3만원 할인 쿠폰은
                  <div style={{ whiteSpace: "pre-line" }}>
                    {user.me
                      ? "[마이웨딩 > 1:1문의] 채팅창으로 지급될 예정입니다."
                      : `웨딩북 앱 내 채팅창으로 지급될 예정입니다.
								문자로 발송되는 링크를 통해
								웨딩북 앱을 다운로드해주세요.`}
                  </div>
                </p>
              </div>
            </div>
            
            {/* 신혼여행 섹션 */}
            <HoneymoonSection 
              title={`${honeymoonTitle} 허니문 추천`}
              description="웨딩홀 예약 커플의 75%가 벌써 신혼여행을 준비하고 있어요."
            />
            
            <button
              className="btn btn-red500 btn-fixed-circle btn-step-complete"
              onClick={() => (window.location.href = "h2mwbell://webview/close")}
            >
              확인
            </button>
          </>
        )}
      </UserContext.Consumer>
    </div>
  );
};

export default Complete;
